<template>
  <div class="lang-selector" :style="istyle" v-popover:popover>
    <li :style="iconStyle" :class="icon" :size="size" style="padding: 8px"></li>
    <el-popover ref="popover" placement="bottom-start" :trigger="trigger" v-model="visible">
      <div class="item" @click="changeLanguage('zh_cn')">简体中文</div>
      <div class="item" @click="changeLanguage('en_us')">English</div>
      <!-- <div class="item" @click="changeLanguage('sau')">اللغة العربية السعودية</div> -->
    </el-popover>
  </div>
</template>

<script>
  export default {
    name: 'LangSelector',
    props: {
      istyle: {
        type: String,
        //default: 'width:60px;'
      },
      icon: {
        type: String,
        default: 'fa fa-language fa-lg'
      },
      iconStyle: {
        type: String,
        default: 'color:#14889A;'
      },
      size:{
         type: String,
          default: 'small'
      },
      trigger: {
        type: String,
        default: 'click'
      }
    },
    data() {
      return {
        visible: false
      }
    },
    methods: {
      // 语言切换
      changeLanguage(lang) {
        debugger
        lang === '' ? 'zh_cn' : lang
        this.$i18n.locale = lang
        window.localStorage.setItem("lang",lang)

        this.visible = false
        // main.js 中的new Vue({  el: '#app',  i18n,  router,  store,  render: h => h(App)}); 的router、store相关数据无法刷新，采用强制全部重新加载方式与会处理
        this.$router.go(0)
      }
    }
  }
</script>
<style scoped lang="scss">
.item {
  font-size: 16px;
  padding-left: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  cursor: pointer;
}
.lang-selector:hover {
  background: #636b6931;
}
.item:hover {
  font-size: 18px;
  background: #b0d6ce4d;
}
</style>


// WEBPACK FOOTER //
// src/components/LangSelector/index.vue